import { SagaIterator } from 'redux-saga';
import { select, all, takeEvery, put } from 'redux-saga/effects';
import { StreamInitConfig } from '@wix/da-shared-react/pkg/Stream/withOffset/types';
import { initializeIfNeeded } from '@wix/da-shared-react/pkg/Stream/base/actions';
import { getNextOffset } from '@wix/da-shared-react/pkg/Stream/withOffset/selectors';
import { getItemsPerFetch } from '@wix/da-shared-react/pkg/Stream/base/selectors';
import { takeStreamFetch, fetchStreamContents } from '@wix/da-shared-react/pkg/Stream/helpers';
import { POINTS_TRANSACTIONS_STREAM } from '../../constants';
import { initializeTransactionsV3, fetchNextTransactionsV3 } from '../actions/points';
import { pointsTransactionsStreamConfig } from '../helpers/streams';
import { PapiRequestDacheckoutPointsInit, PapiDacheckoutPointsInit } from '@wix/da-papi-types';

function* initializeTransactionsV3Saga({
  payload: { hasMore, nextOffset, results },
}: ReturnType<typeof initializeTransactionsV3>) {
  const streamConfig: StreamInitConfig = {
    ...pointsTransactionsStreamConfig,
    autoFetch: false,
    hasMore,
    nextOffset: nextOffset ?? undefined,
    items: results,
  };
  yield put(initializeIfNeeded(POINTS_TRANSACTIONS_STREAM, streamConfig));
}

function* fetchNextTransactionsV3Saga({
  payload: { streamId },
}: ReturnType<typeof fetchNextTransactionsV3>) {
  const { offset, limit } = yield select(state => ({
    offset: getNextOffset(state, streamId),
    limit: getItemsPerFetch(state, streamId),
  }));
  yield fetchStreamContents<PapiRequestDacheckoutPointsInit, PapiDacheckoutPointsInit>({
    streamId,
    params: {
      offset: offset,
      limit: limit,
    },
    url: '/points/init',
    papiProject: 'dacheckout',
    getStreamData: result => ({
      hasMore: !!result.hasMore,
      items: result.transactionsV3 ?? [],
      nextOffset: result.nextOffset ?? undefined,
    }),
  });
}

export default function* saga(): SagaIterator {
  yield all([
    takeEvery(initializeTransactionsV3, initializeTransactionsV3Saga),
    takeStreamFetch(fetchNextTransactionsV3, fetchNextTransactionsV3Saga),
  ]);
}
